<template>
  <v-card>
    <v-card-title>
      <h3 class="toolbar__title">Coil Settings</h3>
    </v-card-title>
    <v-card-text class="coil-settings-container">
      <v-chip v-for="(setting, key) in coilSettings" :key="key" :color="getSettingColor(setting)" text-color="white" class="mr-2 mb-2">
        <b>{{ setting.name }}</b>:{{ setting.value }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: {
      coilSettings: Array
    },
    methods: {
      getSettingColor (setting) {
        switch (setting.name) {
          case '全':
            return 'red'
          case '半':
            return 'blue'
          case '小':
            return 'green'
        }
        switch (setting.value) {
          case '高':
            return 'red'
          case '低':
            return 'blue'
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Information/CoilSettings.vue